import { isCarsTrucks } from '@kijiji/category'
import { SellerType } from '@kijiji/generated/graphql-types'

import { VALUE_ESTIMATE_ALLOWLIST } from '@/constants/autoCanada'
import { type LocationPath } from '@/types/location'

export const isAutocanValueEstimateAvailable = ({
  categoryId,
  isDealerListing,
  locationPath,
  sellerType,
}: {
  categoryId: number
  isDealerListing: boolean
  locationPath: LocationPath[]
  sellerType: SellerType
}) => {
  /** Value Estimate should be launched in location */
  const allowedLocation = locationPath.some((location) =>
    VALUE_ESTIMATE_ALLOWLIST.includes(location.id)
  )

  /** It should be a FSBO listing */
  const isAllowedSeller = sellerType === SellerType.Fsbo && !isDealerListing

  /** It should be on Cars & Trucks Category */
  const allowedCategory = isCarsTrucks(categoryId)

  return allowedLocation && allowedCategory && isAllowedSeller
}
